/**
 * Paths for chart.
 * - proxy: Next.js API route used by client on BZ domain (/api/chart, /api/chart/bars)
 * - upstream: external data API (server-side)
 */
export const chartRoutes = {
  bars: { proxy: 'chart/bars', upstream: 'v2/bars' },
  chart: { proxy: 'chart', upstream: 'v2/chart' },
} as const;
